import React, { useEffect, useState } from 'react';
import { IoIosCloseCircle, IoMdCloudUpload } from 'react-icons/io';
import { BiImageAdd, BiRevision } from 'react-icons/bi';
import { MdDragIndicator } from 'react-icons/md';
import defaultImg from "../../../assets/images/product/defaultImg.svg";
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { fetchBanner } from '../../../Redux/Reducers/BannerReducer';
import toast from 'react-hot-toast';
import { uploadImagecertifates } from '../../../Redux/Actions/Action';
import {
    Box, Tabs, Tab, Button, FormControl, Select, MenuItem,
    Typography, Chip, CircularProgress, Skeleton, Fade,
    Autocomplete, TextField, Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import { validateFile } from "../../../utils/comman-function";

const REDIRECT_OPTIONS = [
    { label: 'Recharge Pack', value: 'recharge_pack' },
    { label: 'Connect Page', value: 'connect_page' },
    { label: 'Shastriji', value: 'shastriji' },
    { label: 'Services', value: 'services' },
    { label: 'Pooja Listing', value: 'pooja_listing' },
    { label: 'Pooja Details', value: 'pooja_details' },
    // { label: 'Custom URL', value: 'custom' },
];

const WEB_AND_TOGGLE_REDIRECT_OPTIONS = REDIRECT_OPTIONS.filter(
    (opt) => opt.value !== 'recharge_pack' && opt.value !== 'services'
);

const MAX_BANNERS = 6;

const emptySlot = () => ({ imageUrl: null, redirectFor: '', poojaId: '', customUrl: '' });
const createEmptySlots = () => Array(MAX_BANNERS).fill(null).map(() => emptySlot());

function Topbanner() {
    const dispatch = useDispatch();
    const banners = useSelector(state => state?.BannerReducer?.banner);

    // Derived state for handling loading phases
    const [fetching, setFetching] = useState(true);
    const [uploadingIndex, setUploadingIndex] = useState(null); // Track which slot is uploading
    const [saving, setSaving] = useState(false);

    const [webSlots, setWebSlots] = useState(createEmptySlots());
    const [mobileSlots, setMobileSlots] = useState(createEmptySlots());
    const [toggleSlots, setToggleSlots] = useState(createEmptySlots());
    const [activeTab, setActiveTab] = useState("web");

    // Drag and Drop reordering state (within active tab)
    const [draggedSlotIndex, setDraggedSlotIndex] = useState(null);
    const [dragOverSlotIndex, setDragOverSlotIndex] = useState(null);

    // Confirmation dialog state for position update
    const [reorderConfirmDialog, setReorderConfirmDialog] = useState({
        open: false,
        sourceIndex: null,
        targetIndex: null
    });
    const [updatingPosition, setUpdatingPosition] = useState(false);

    // Delete confirmation dialog state
    const [deleteConfirmDialog, setDeleteConfirmDialog] = useState({
        open: false,
        slotIndex: null
    });
    const [deleting, setDeleting] = useState(false);

    const [poojaList, setPoojaList] = useState([]);
    const [poojaListLoading, setPoojaListLoading] = useState(false);

    useEffect(() => {
        dispatch(fetchBanner()).then(() => setFetching(false));
        fetchPoojaList();
    }, [dispatch]);

    const fetchPoojaList = async () => {
        try {
            setPoojaListLoading(true);
            const token = localStorage.getItem('astroVani-admin-token');
            const response = await axios.get(
                `${process.env.REACT_APP_BASEURL}/admin/pooja?page=1&limit=500`,
                { headers: { Authorization: token } }
            );
            const data = response.data;
            const list = Array.isArray(data?.data?.data) ? data.data.data : Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
            setPoojaList(list);
        } catch (err) {
            console.error('Error fetching pooja list:', err);
        } finally {
            setPoojaListLoading(false);
        }
    };

    // Data Sync Logic
    const extractBannerData = (bannerType) => {
        const banner = banners?.find(b => b.bannerType === bannerType);
        if (!banner) return null;

        if (banner.heroBannersRedirection?.length > 0) {
            return banner.heroBannersRedirection;
        }
        if (banner.heroBanners?.length > 0) {
            return banner.heroBanners.map(url => ({ imageUrl: url, redirectFor: '' }));
        }
        return null;
    };

    useEffect(() => {
        const populateSlots = (data, bannerType) => {
            if (!data) return createEmptySlots();
            const slots = data.slice(0, MAX_BANNERS).map(item => {
                const isDisallowed = (bannerType === 'forWeb' || bannerType === 'forMobileView') &&
                    (item.redirectFor === 'recharge_pack' || item.redirectFor === 'services');
                return {
                    imageUrl: item.imageUrl || null,
                    redirectFor: isDisallowed ? '' : (item.redirectFor || ''),
                    poojaId: item.poojaId || '',
                    customUrl: item.redirectFor === 'custom' && item.redirectionUrl ? item.redirectionUrl : ''
                };
            });
            while (slots.length < MAX_BANNERS) slots.push(emptySlot());
            return slots;
        };

        if (banners.length > 0 || !fetching) {
            const webData = extractBannerData("forWeb");
            const mobileData = extractBannerData("forMobile");
            const toggleData = extractBannerData("forMobileView");

            if (webData) setWebSlots(populateSlots(webData, "forWeb"));
            if (mobileData) setMobileSlots(populateSlots(mobileData, "forMobile"));
            if (toggleData) setToggleSlots(populateSlots(toggleData, "forMobileView"));
        }
    }, [banners, fetching]);

    const getActiveSlots = () => {
        if (activeTab === "web") return webSlots;
        if (activeTab === "mobile") return mobileSlots;
        return toggleSlots;
    };

    const getActiveSetter = () => {
        if (activeTab === "web") return setWebSlots;
        if (activeTab === "mobile") return setMobileSlots;
        return setToggleSlots;
    };

    // Specific Slot Upload
    const handleSlotUpload = async (event, index) => {
        const file = event.target.files?.[0];
        if (!file) return;

        if (!validateFile(file, file.type.startsWith('video') ? 'video' : 'image')) {
            toast.error("Invalid file format");
            return;
        }

        setUploadingIndex(index);

        try {
            const uploadedUrl = await dispatch(uploadImagecertifates(file));
            if (uploadedUrl) {
                const slots = [...getActiveSlots()];
                const setter = getActiveSetter();
                // Preserve existing redirect if just replacing image, else reset
                const currentRedirect = slots[index].redirectFor;
                const isDisallowed = (activeTab === 'web' || activeTab === 'toggle') &&
                    (currentRedirect === 'recharge_pack' || currentRedirect === 'services');
                slots[index] = {
                    imageUrl: uploadedUrl.toString(),
                    redirectFor: isDisallowed ? '' : (currentRedirect || '') // Keep existing redirect preference if replacing
                };
                setter(slots);
                toast.success("Image uploaded successfully");
            }
        } catch (err) {
            console.error(err);
            toast.error("Upload failed");
        } finally {
            setUploadingIndex(null);
            event.target.value = ''; // Reset input
        }
    };

    const handleRemoveImage = (index) => {
        const setter = getActiveSetter();
        const slots = [...getActiveSlots()];
        slots[index] = emptySlot();
        setter(slots);
    };

    const handleConfirmDelete = async () => {
        const { slotIndex } = deleteConfirmDialog;
        if (slotIndex === null) return;

        const updatedSlots = [...getActiveSlots()];
        updatedSlots[slotIndex] = emptySlot();

        setDeleting(true);
        try {
            const success = await saveBannerSlots(updatedSlots, `Banner deleted successfully from Slot #${slotIndex + 1}!`);
            if (success) {
                const setter = getActiveSetter();
                setter(updatedSlots);
                setDeleteConfirmDialog({ open: false, slotIndex: null });
            }
        } catch (error) {
            console.error('Error deleting banner:', error);
            toast.error(error.response?.data?.message || 'Error deleting banner');
        } finally {
            setDeleting(false);
        }
    };

    // Drag and Drop reordering within the same tab
    const handleDragStart = (e, index) => {
        setDraggedSlotIndex(index);
        e.dataTransfer.setData('text/plain', String(index));
        e.dataTransfer.effectAllowed = 'move';
    };

    const handleDragOver = (e, index) => {
        const slots = getActiveSlots();
        // Drop is strictly ONLY allowed on slots that already have images (filled slots)
        if (!slots[index]?.imageUrl) {
            return;
        }
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        if (dragOverSlotIndex !== index) {
            setDragOverSlotIndex(index);
        }
    };

    const handleDragLeave = (e) => {
        if (e.currentTarget.contains(e.relatedTarget)) return;
        setDragOverSlotIndex(null);
    };

    const handleDragEnd = () => {
        setDraggedSlotIndex(null);
        setDragOverSlotIndex(null);
    };

    const handleDrop = (e, targetIndex) => {
        e.preventDefault();
        setDragOverSlotIndex(null);
        const sourceIndex = draggedSlotIndex;
        setDraggedSlotIndex(null);

        if (sourceIndex === null || sourceIndex === targetIndex) {
            return;
        }

        const slots = getActiveSlots();
        // Drop validation: drop is ONLY allowed on slots that already have images
        if (!slots[targetIndex]?.imageUrl) {
            toast.error('Drop is only allowed on filled slots with images. Empty slots cannot be reordered into.');
            return;
        }
        if (!slots[sourceIndex]?.imageUrl) {
            toast.error('Only filled slots can be dragged.');
            return;
        }

        // Open confirmation popup before applying position change & saving
        setReorderConfirmDialog({
            open: true,
            sourceIndex,
            targetIndex
        });
    };

    const handleRedirectChange = (index, value) => {
        const setter = getActiveSetter();
        const slots = [...getActiveSlots()];
        slots[index] = { ...slots[index], redirectFor: value, poojaId: value === 'pooja_details' ? slots[index].poojaId : '', customUrl: value === 'custom' ? slots[index].customUrl : '' };
        setter(slots);
    };

    const handleCustomUrlChange = (index, value) => {
        const setter = getActiveSetter();
        const slots = [...getActiveSlots()];
        slots[index] = { ...slots[index], customUrl: value };
        setter(slots);
    };

    const handlePoojaChange = (index, value) => {
        const setter = getActiveSetter();
        const slots = [...getActiveSlots()];
        slots[index] = { ...slots[index], poojaId: value };
        setter(slots);
    };

    const saveBannerSlots = async (slotsToSave, customSuccessMessage) => {
        // Validation: Check if any image slot is missing a redirect option or has disallowed redirect option
        const invalidSlots = slotsToSave.some(s => {
            if (!s.imageUrl) return false;
            if (!s.redirectFor) return true;
            if ((activeTab === 'web' || activeTab === 'toggle') && (s.redirectFor === 'recharge_pack' || s.redirectFor === 'services')) {
                return true;
            }
            return false;
        });
        if (invalidSlots) {
            toast.error("Please select a valid 'Redirect To' option for all active banners.");
            return false;
        }

        let bannerType = "forWeb";
        if (activeTab === "mobile") bannerType = "forMobile";
        else if (activeTab === "toggle") bannerType = "forMobileView";

        const filledSlots = slotsToSave.filter(s => s.imageUrl !== null);

        const payload = {
            bannerType,
            heroBanners: filledSlots.map(s => s.imageUrl),
            heroBannersRedirection: filledSlots.map(s => {
                const base = {
                    imageUrl: s.imageUrl,
                    redirectFor: s.redirectFor || 'custom',
                };
                if (s.redirectFor === 'pooja_details' && s.poojaId) {
                    base.poojaId = s.poojaId;
                    base.redirectionUrl = `/pooja-details/${s.poojaId}`;
                } else if (s.redirectFor === 'custom' && s.customUrl) {
                    base.redirectionUrl = s.customUrl;
                }
                return base;
            }),
        };

        const token = localStorage.getItem("astroVani-admin-token");
        const response = await axios.post(
            `${process.env.REACT_APP_BASEURL}/admin/banner`,
            payload,
            { headers: { 'Authorization': token, 'Content-Type': 'application/json' } }
        );

        if (response.data?.success) {
            toast.success(customSuccessMessage || `Banner positions updated and saved successfully!`);
            dispatch(fetchBanner());
            return true;
        } else {
            toast.error(response.data?.message || 'Failed to update banner');
            return false;
        }
    };

    const handleConfirmPositionChange = async () => {
        const { sourceIndex, targetIndex } = reorderConfirmDialog;
        if (sourceIndex === null || targetIndex === null) return;

        const currentSlots = [...getActiveSlots()];
        // Swap the slots at sourceIndex and targetIndex
        const temp = currentSlots[sourceIndex];
        currentSlots[sourceIndex] = currentSlots[targetIndex];
        currentSlots[targetIndex] = temp;

        setUpdatingPosition(true);
        try {
            const success = await saveBannerSlots(currentSlots);
            if (success) {
                const setter = getActiveSetter();
                setter(currentSlots);
                setReorderConfirmDialog({ open: false, sourceIndex: null, targetIndex: null });
            }
        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || 'Error updating banner position');
        } finally {
            setUpdatingPosition(false);
        }
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            await saveBannerSlots(getActiveSlots(), 'Banners saved successfully!');
        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || 'Error updating banner');
        } finally {
            setSaving(false);
        }
    };

    const handleTabChange = (val) => {
        setActiveTab(val);
        // Optional: Refetch if needed, but we rely on initial fetch + local state mostly
    };

    const currentRedirectOptions = activeTab === 'mobile' ? REDIRECT_OPTIONS : WEB_AND_TOGGLE_REDIRECT_OPTIONS;

    return (
        <div className="container-xxl">
            {/* --- Premium Header --- */}
            <Box sx={{ py: 3, mb: 1 }}>
                <Typography sx={{
                    fontSize: '24px', fontWeight: 800, color: '#1a1a1a',
                    letterSpacing: '-0.5px', fontFamily: '"Inter", sans-serif'
                }}>
                    Top Banners <span style={{ color: '#E7B437' }}>*</span>
                </Typography>
                <Typography sx={{ fontSize: '14px', color: '#666', mt: 0.5, fontWeight: 500 }}>
                    Design your app's hero section. Upload up to 6 banners with smart redirection. Drag by the position badge (e.g. #1, #2) to reorder slots within this tab.
                </Typography>
            </Box>

            {/* --- Navigation Tabs (Left) & Save Button (Right) --- */}
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 2,
                mb: 4
            }}>
                {/* Tabs on Left */}
                <Box sx={{
                    p: 0.8, backgroundColor: '#fff', borderRadius: '16px',
                    display: 'inline-flex', boxShadow: '0 4px 20px rgba(0,0,0,0.04)', border: '1px solid #f0f0f0'
                }}>
                    {['web', 'mobile', 'toggle'].map((tab) => (
                        <Button
                            key={tab}
                            onClick={() => handleTabChange(tab)}
                            sx={{
                                px: 4, py: 1.2, borderRadius: '12px', textTransform: 'none',
                                fontSize: '14px', fontWeight: 700,
                                color: activeTab === tab ? '#fff' : '#666',
                                background: activeTab === tab ? '#E7B437' : 'transparent',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    background: activeTab === tab ? '#E7B437' : '#f8f8f8',
                                    color: activeTab === tab ? '#fff' : '#333',
                                }
                            }}
                        >
                            {tab === 'web' ? 'Web View' : tab === 'mobile' ? 'App View' : 'Mobile View'}
                        </Button>
                    ))}
                </Box>

                {/* Save Button on Right */}
                <Button
                    variant="contained"
                    onClick={handleSave}
                    disabled={saving || uploadingIndex !== null}
                    startIcon={saving ? <CircularProgress size={18} thickness={5} sx={{ color: '#fff' }} /> : null}
                    sx={{
                        borderRadius: '12px', textTransform: 'none', px: 4, py: 1.3,
                        fontSize: '14px', fontWeight: 700,
                        background: 'linear-gradient(135deg, #E7B437, #d4a02e)', // Gold premium gradient
                        color: '#fff',
                        boxShadow: '0 8px 16px rgba(231, 180, 55, 0.25)',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                            background: 'linear-gradient(135deg, #d4a02e, #c4920e)',
                            boxShadow: '0 12px 24px rgba(231, 180, 55, 0.35)',
                            transform: 'translateY(-2px)'
                        },
                        '&:active': { transform: 'translateY(0)' },
                        '&:disabled': { background: '#f0f0f0', color: '#aaa', boxShadow: 'none' },
                    }}
                >
                    {saving ? 'Saving...' : 'Save'}
                </Button>
            </Box>

            {/* --- Banner Grid System --- */}
            {fetching ? (
                <div className="row g-4">
                    {[1, 2, 3].map(i => (
                        <div className="col-lg-4 col-md-6" key={i}>
                            <Skeleton variant="rectangular" height={280} sx={{ borderRadius: '20px' }} />
                        </div>
                    ))}
                </div>
            ) : (
                <div className="row g-4">
                    {getActiveSlots().map((slot, index) => {
                        const isFilled = !!slot.imageUrl;
                        const isUploading = uploadingIndex === index;

                        return (
                            <div className="col-lg-4 col-md-6" key={index}>
                                <Fade in={true} timeout={500 + (index * 100)}>
                                    <Box
                                        onDragOver={(e) => isFilled && handleDragOver(e, index)}
                                        onDragLeave={handleDragLeave}
                                        onDrop={(e) => isFilled && handleDrop(e, index)}
                                        sx={{
                                            position: 'relative',
                                            borderRadius: '20px',
                                            backgroundColor: dragOverSlotIndex === index ? '#fffef5' : '#fff',
                                            border: dragOverSlotIndex === index
                                                ? '2px dashed #E7B437 !important'
                                                : isFilled ? '2px solid transparent' : '2px dashed #e0e0e0',
                                            backgroundImage: isFilled && dragOverSlotIndex !== index ? 'none' : 'linear-gradient(135deg, #fafafa 0%, #fff 100%)',
                                            backgroundClip: isFilled ? 'padding-box' : 'border-box',
                                            boxShadow: dragOverSlotIndex === index
                                                ? '0 0 20px rgba(231,180,55,0.35)'
                                                : isFilled ? '0 12px 32px rgba(0,0,0,0.06)' : 'none',
                                            opacity: draggedSlotIndex === index ? 0.45 : 1,
                                            transform: dragOverSlotIndex === index ? 'scale(1.02)' : 'none',
                                            transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                                            height: '100%',
                                            display: 'flex', flexDirection: 'column',
                                            overflow: 'hidden',
                                            '&:hover': {
                                                borderColor: '#E7B437',
                                                transform: dragOverSlotIndex === index ? 'scale(1.02)' : 'translateY(-4px)',
                                                boxShadow: '0 16px 40px rgba(231,180,55,0.12)',
                                            }
                                        }}
                                    >
                                        {/* Image Area */}
                                        <Box
                                            sx={{
                                                height: '200px', width: '100%', position: 'relative',
                                                backgroundColor: '#f8f9fa', overflow: 'hidden',
                                                cursor: !isFilled ? 'pointer' : 'default',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center'
                                            }}
                                            component="label" // Make entire area clickable for upload if empty
                                        >
                                            {isFilled ? (
                                                <>
                                                    <img
                                                        src={slot.imageUrl} alt={`banner-${index}`}
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                    />

                                                    {/* Hover Overlay for Replace */}
                                                    <Box sx={{
                                                        position: 'absolute', inset: 0,
                                                        background: 'rgba(0,0,0,0.4)',
                                                        opacity: 0, transition: 'opacity 0.2s',
                                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                        '&:hover': { opacity: 1 }
                                                    }}>
                                                        <Button
                                                            component="span"
                                                            variant="contained" size="small"
                                                            startIcon={<BiRevision />}
                                                            sx={{
                                                                bgcolor: '#fff', color: '#333', fontWeight: 700, textTransform: 'none',
                                                                '&:hover': { bgcolor: '#f0f0f0' }
                                                            }}
                                                        >
                                                            Replace Image
                                                        </Button>
                                                    </Box>
                                                    <input hidden type="file" accept="image/*" onChange={(e) => handleSlotUpload(e, index)} />
                                                </>
                                            ) : (
                                                <>
                                                    <Box sx={{ textAlign: 'center', color: '#aaa', transition: '0.3s', p: 2 }}>
                                                        {isUploading ? (
                                                            <CircularProgress size={32} sx={{ color: '#E7B437', mb: 1 }} />
                                                        ) : (
                                                            <BiImageAdd style={{ fontSize: '48px', marginBottom: '8px', color: '#e0e0e0' }} />
                                                        )}
                                                        <Typography sx={{ fontWeight: 600, fontSize: '14px', color: isUploading ? '#E7B437' : 'inherit' }}>
                                                            {isUploading ? 'Uploading...' : `Slot ${index + 1}`}
                                                        </Typography>
                                                        {!isUploading && (
                                                            <Typography sx={{ fontSize: '12px', mt: 0.5, opacity: 0.7 }}>
                                                                Click to upload
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                    <input hidden type="file" accept="image/*" disabled={isUploading} onChange={(e) => handleSlotUpload(e, index)} />
                                                </>
                                            )}

                                            {/* Position Badge & Drag Handle */}
                                            {isFilled && (
                                                <Box
                                                    draggable={true}
                                                    onDragStart={(e) => handleDragStart(e, index)}
                                                    onDragEnd={handleDragEnd}
                                                    sx={{
                                                        position: 'absolute', top: 12, left: 12, zIndex: 3,
                                                        height: 32, borderRadius: '10px',
                                                        background: 'rgba(255,255,255,0.95)',
                                                        backdropFilter: 'blur(8px)',
                                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                        px: 1, gap: 0.5,
                                                        fontWeight: 800, fontSize: '13px', color: '#1a1a1a',
                                                        boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
                                                        cursor: 'grab',
                                                        transition: 'all 0.2s ease',
                                                        userSelect: 'none',
                                                        border: '1px solid rgba(231,180,55,0.3)',
                                                        '&:hover': {
                                                            background: '#fff',
                                                            boxShadow: '0 6px 16px rgba(231,180,55,0.4)',
                                                            borderColor: '#E7B437',
                                                            transform: 'scale(1.05)'
                                                        },
                                                        '&:active': { cursor: 'grabbing' },
                                                    }}
                                                    title="Drag to change position within this tab"
                                                >
                                                    <MdDragIndicator style={{ fontSize: '18px', color: '#E7B437' }} />
                                                    <span>#{index + 1}</span>
                                                </Box>
                                            )}

                                            {/* Delete Button */}
                                            {isFilled && (
                                                <Box
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        setDeleteConfirmDialog({
                                                            open: true,
                                                            slotIndex: index
                                                        });
                                                    }}
                                                    sx={{
                                                        position: 'absolute', top: 12, right: 12, zIndex: 2,
                                                        width: 32, height: 32, borderRadius: '50%',
                                                        background: '#fff', cursor: 'pointer',
                                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                                                        transition: '0.2s', '&:hover': { transform: 'scale(1.1)', color: '#d32f2f' }
                                                    }}
                                                >
                                                    <IoIosCloseCircle size={22} color="#ff4444" />
                                                </Box>
                                            )}
                                        </Box>

                                        {/* Configuration Section */}
                                        <Box sx={{ p: 2.5, flex: 1, display: 'flex', flexDirection: 'column', gap: 1.5, opacity: isFilled ? 1 : 0.5, pointerEvents: isFilled ? 'auto' : 'none', filter: isFilled ? 'none' : 'grayscale(1)' }}>
                                            <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.6px' }}>
                                                Navigation Action
                                            </Typography>

                                            <FormControl fullWidth size="small">
                                                <Select
                                                    value={slot.redirectFor}
                                                    displayEmpty
                                                    onChange={(e) => handleRedirectChange(index, e.target.value)}
                                                    sx={{
                                                        borderRadius: '10px', fontSize: '14px',
                                                        backgroundColor: '#f8f9fa',
                                                        boxShadow: 'none',
                                                        '.MuiOutlinedInput-notchedOutline': { border: '1px solid #eee' },
                                                        '&:hover .MuiOutlinedInput-notchedOutline': { border: '1px solid #E7B437' },
                                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: '1px solid #E7B437' },
                                                        '&.Mui-focused': { backgroundColor: '#fff' }
                                                    }}
                                                    renderValue={(selected) => {
                                                        if (!selected) return <Typography sx={{ color: '#bbb', fontSize: '13px' }}>Choose destination...</Typography>;
                                                        let label = REDIRECT_OPTIONS.find(o => o.value === selected)?.label;
                                                        if (!label && selected === 'pooja_listing') label = 'Pooja Listing';
                                                        if (!label && selected === 'pooja_details') label = 'Pooja Details';
                                                        return label || selected;
                                                    }}
                                                >
                                                    {currentRedirectOptions.map((opt) => (
                                                        <MenuItem key={opt.value} value={opt.value} sx={{ fontSize: '13px', fontWeight: 500, py: 1.5 }}>
                                                            {opt.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>

                                            {slot.redirectFor === 'custom' && (
                                                <Box sx={{ mt: 1 }}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        placeholder="Enter Custom URL"
                                                        value={slot.customUrl || ''}
                                                        onChange={(e) => handleCustomUrlChange(index, e.target.value)}
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                borderRadius: '10px', backgroundColor: '#f8f9fa', fontSize: '13px',
                                                                '& fieldset': { borderColor: '#eee' },
                                                                '&:hover fieldset': { borderColor: '#E7B437' },
                                                                '&.Mui-focused fieldset': { borderColor: '#E7B437' },
                                                                '&.Mui-focused': { backgroundColor: '#fff' }
                                                            }
                                                        }}
                                                    />
                                                </Box>
                                            )}

                                            {slot.redirectFor === 'pooja_details' && (
                                                <Box sx={{ mt: 1 }}>
                                                    <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.6px', mb: 1 }}>
                                                        Select Pooja
                                                    </Typography>
                                                    <Autocomplete
                                                        size="small"
                                                        options={poojaList}
                                                        loading={poojaListLoading}
                                                        getOptionLabel={(opt) => opt.name || ''}
                                                        value={poojaList.find((p) => p._id === slot.poojaId) || null}
                                                        onChange={(_, newVal) => handlePoojaChange(index, newVal?._id || '')}
                                                        isOptionEqualToValue={(opt, val) => opt._id === val._id}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Search and select..."
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    endAdornment: (
                                                                        <>
                                                                            {poojaListLoading ? <CircularProgress size={16} sx={{ color: '#E7B437' }} /> : null}
                                                                            {params.InputProps.endAdornment}
                                                                        </>
                                                                    ),
                                                                }}
                                                                sx={{
                                                                    '& .MuiOutlinedInput-root': {
                                                                        borderRadius: '10px', backgroundColor: '#f8f9fa', fontSize: '13px',
                                                                        '& fieldset': { borderColor: '#eee' },
                                                                        '&:hover fieldset': { borderColor: '#E7B437' },
                                                                        '&.Mui-focused fieldset': { borderColor: '#E7B437' },
                                                                        '&.Mui-focused': { backgroundColor: '#fff' }
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                        renderOption={(props, option) => (
                                                            <li {...props} key={option._id}>
                                                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                                    <Typography sx={{ fontSize: '13px', fontWeight: 600 }}>{option.name}</Typography>
                                                                    {option.basePrice && (
                                                                        <Typography sx={{ fontSize: '11px', color: '#999' }}>₹{option.basePrice}</Typography>
                                                                    )}
                                                                </Box>
                                                            </li>
                                                        )}
                                                        noOptionsText="No poojas found"
                                                    />
                                                </Box>
                                            )}

                                            {/* Status Indicator */}
                                            {/* {isFilled && (
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                                                    <Box sx={{
                                                        width: 6, height: 6, borderRadius: '50%',
                                                        bgcolor: slot.redirectFor ? '#2e7d32' : '#d32f2f'
                                                    }} />
                                                    <Typography sx={{ fontSize: '12px', fontWeight: 600, color: slot.redirectFor ? '#2e7d32' : '#d32f2f' }}>
                                                        {slot.redirectFor ? 'Ready to publish' : 'Action required'}
                                                    </Typography>
                                                </Box>
                                            )} */}
                                        </Box>
                                    </Box>
                                </Fade>
                            </div>
                        );
                    })}
                </div>
            )}

            {/* Delete Confirmation Dialog */}
            <Dialog
                open={deleteConfirmDialog.open}
                onClose={() => !deleting && setDeleteConfirmDialog({ open: false, slotIndex: null })}
                PaperProps={{
                    sx: { borderRadius: '18px', padding: '10px', minWidth: '340px' }
                }}
            >
                <DialogTitle sx={{ fontWeight: 800, color: '#222', fontSize: '18px', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <span style={{ fontSize: '20px', color: '#d32f2f' }}>🗑️</span> Confirm Deletion
                </DialogTitle>
                <DialogContent>
                    <Typography sx={{ color: '#555', fontSize: '14.5px', mb: 2 }}>
                        Are you sure you want to delete the banner in <strong>Slot #{(deleteConfirmDialog.slotIndex ?? 0) + 1}</strong>?
                    </Typography>
                    {/* {deleteConfirmDialog.slotIndex !== null && getActiveSlots()[deleteConfirmDialog.slotIndex]?.imageUrl && (
                        <Box
                            sx={{
                                width: '100%',
                                height: '120px',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                border: '1px solid #eee',
                                mb: 1,
                                backgroundColor: '#f8f9fa'
                            }}
                        >
                            <img
                                src={getActiveSlots()[deleteConfirmDialog.slotIndex].imageUrl}
                                alt="banner preview"
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                        </Box>
                    )} */}
                    <Typography sx={{ color: '#888', fontSize: '12px', mt: 1 }}>
                        Confirming will immediately delete this banner and update the live API.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ padding: '16px 24px', gap: 1 }}>
                    <Button
                        onClick={() => setDeleteConfirmDialog({ open: false, slotIndex: null })}
                        disabled={deleting}
                        sx={{ color: '#888', textTransform: 'none', fontWeight: 700 }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirmDelete}
                        variant="contained"
                        disabled={deleting}
                        startIcon={deleting ? <CircularProgress size={16} sx={{ color: '#fff' }} /> : null}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 700,
                            borderRadius: '8px',
                            px: 3,
                            backgroundColor: '#d32f2f',
                            '&:hover': { backgroundColor: '#b71c1c' }
                        }}
                    >
                        {deleting ? 'Deleting...' : 'Delete'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Position Reorder Confirmation Dialog */}
            <Dialog
                open={reorderConfirmDialog.open}
                onClose={() => !updatingPosition && setReorderConfirmDialog({ open: false, sourceIndex: null, targetIndex: null })}
                PaperProps={{
                    sx: { borderRadius: '18px', padding: '10px', minWidth: '380px' }
                }}
            >
                <DialogTitle sx={{ fontWeight: 800, color: '#222', fontSize: '18px', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <span style={{ fontSize: '20px' }}>🔄</span> Confirm Position Change
                </DialogTitle>
                <DialogContent>
                    <Typography sx={{ color: '#555', fontSize: '14.5px', mb: 2 }}>
                        Are you sure you want to swap the position of these banners?
                    </Typography>
                    <Box
                        sx={{
                            background: 'linear-gradient(135deg, #FFF9E6 0%, #FFF3CC 100%)',
                            borderRadius: '12px',
                            p: 2,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 2,
                            border: '1px solid #f0e0a0',
                            fontWeight: 700,
                            fontSize: '15px',
                            color: '#333'
                        }}
                    >
                        <Chip
                            label={`Slot #${(reorderConfirmDialog.sourceIndex ?? 0) + 1}`}
                            sx={{ fontWeight: 800, background: '#E7B437', color: '#fff', fontSize: '13px' }}
                        />
                        <span style={{ fontSize: '20px', color: '#888' }}>⇄</span>
                        <Chip
                            label={`Slot #${(reorderConfirmDialog.targetIndex ?? 0) + 1}`}
                            sx={{ fontWeight: 800, background: '#E7B437', color: '#fff', fontSize: '13px' }}
                        />
                    </Box>
                    <Typography sx={{ color: '#888', fontSize: '12px', mt: 2 }}>
                        Confirming will immediately update the banner positions and save the changes to the live API.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ padding: '16px 24px', gap: 1 }}>
                    <Button
                        onClick={() => setReorderConfirmDialog({ open: false, sourceIndex: null, targetIndex: null })}
                        disabled={updatingPosition}
                        sx={{ color: '#888', textTransform: 'none', fontWeight: 700 }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirmPositionChange}
                        variant="contained"
                        disabled={updatingPosition}
                        startIcon={updatingPosition ? <CircularProgress size={16} sx={{ color: '#fff' }} /> : null}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 700,
                            borderRadius: '8px',
                            px: 3,
                            background: 'linear-gradient(135deg, #E7B437, #d4a02e)',
                            '&:hover': { background: 'linear-gradient(135deg, #d4a02e, #c4920e)' }
                        }}
                    >
                        {updatingPosition ? 'Updating...' : 'Confirm & Update'}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default Topbanner;
